// Packages
import React from "react"
import PropTypes from "prop-types"

// Actions
import { clearFilters } from "components/Stacker/actions/SearchActions"

// Styles
import "./ClearFilter.scss"
import { useDispatch } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

export const ClearFilter = ({ subFilter }) => {
  const dispatch = useDispatch()
  const { LL } = useI18nContext()
  const handleClearFilters = () => {
    dispatch(clearFilters(subFilter))
  }

  return (
    <div className="ClearFilter">
      <button
        className="btn btn-text clear-filter-btn text-black"
        type="button"
        onClick={handleClearFilters}
      >
        {LL.search.clearFiltersText()}
      </button>
    </div>
  )
}

ClearFilter.propTypes = {
  subFilter: PropTypes.string,
}

export default ClearFilter
